import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getList = async (params) => {
	const { data } = await axios.get(`${API}/client/application_orders`, { params });
	return {
		...data,
		permissions: data?.permissions ?? [],
		list: data?.list ?? { data: [], total: 0, last_page: 1, from: 0, to: 0 },
	};
};

export const getCreate = async (params) => {
	const { data } = await axios.get(`${API}/client/application_orders/data_application_orders`, {
		params,
	});
	return data;
};

export const getCodeCreate = async (params) => {
	const { data } = await axios.get(`${API}/client/application_orders/code_create`, {
		params,
	});
	return data;
};

export const saveAppOrder = async ({ params, base }) => {
	const { data } = await axios.post(`${API}/client/application_orders/save`, {
		...base,
		params,
	});
	return data;
};

export const deleteAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/delete`, {
		...base,
		element,
	});
	return data;
};

export const duplicateAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/duplicate`, {
		...base,
		element,
	});

	return data;
};

export const returnStateAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/return_state`, {
		...base,
		element,
	});
	return data;
};

export const checkStatusAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/check_status`, {
		...base,
		element,
	});
	return data;
};

export const approveAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/approve`, {
		...base,
		element,
	});
	return data;
};

export const rejectAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/reject`, {
		...base,
		element,
	});
	return data;
};

export const finishAppOrder = async ({ base, element }) => {
	const { data } = await axios.post(`${API}/client/application_orders/finish`, {
		...base,
		element,
	});
	return data;
};
